// extracted by mini-css-extract-plugin
module.exports = {"NavItem":"HeaderNavItem_NavItem__1bie2","NavLink":"HeaderNavItem_NavLink__SiFoh","closed":"HeaderNavItem_closed__1NNvu","open":"HeaderNavItem_open__2dRck"};